import TopCollectionCard from "../../../components/TopCollectionCard/TopCollectionCard";
import { collections } from "../../../data/collections";


const TopCollections = () => {
    return(
        <div>
            <h1 className='mb-5 secondary_heading leading-60px md:leading-60px 2xl:leading-84px text-lg sm:text-50px md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-bold '>
                Top Collections
            </h1>
            <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-x-5 gap-y-1 md:gap-y-5 mb-5'>
              {collections.map((collection, index) => {
                if(index < 9){
                  return <TopCollectionCard collection = {collection} number = {index} />
                }
                else return null;
                  
              })}
              
              
            </div>
        </div>
    )
}

export default TopCollections;